import React from "react";
import { Dropdown } from "antd";

import { BaseDropdownButtonProps } from "./types";

const BaseDropdownButton = ({
  menu,
  onClick,
  icon,
  children,
  className,
}: BaseDropdownButtonProps) => (
  <Dropdown.Button
    className={`base-dropdown-button ${className}`}
    menu={menu}
    onClick={onClick}
    icon={icon}
  >
    {children}
  </Dropdown.Button>
);

export default BaseDropdownButton;
